





































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Language from "@/models/language/language.model";
import TipoEvaluacion from '@/models/evaluacion/tipoEvaluacion.model';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
import BaseSelectComponent from '@/components/base/baseSelect/baseSelect.vue';
import UrlForm from '@/models/urlForm.model';
import searcherService from "@/services/searcher.service";

@Component({
  components: {
    BaseSelectComponent
  }
})
export default class Edit extends GenericEdit<UrlForm> {
  searcherService = new searcherService();
  urlFormActive: UrlForm = null

  constructor() {
    super();
    this.controller = "UrlForm";
    this.model = new UrlForm();
  }

  async mounted() {
    this.urlFormActive = await this.searcherService.getActiveForm();
  }

}
